const mutations = {
  setVerifyParam (state, obj) {
    state.requestParameter = obj;
  },
  saveFilterList (state, obj) {
    state.filterList = obj;
  },
  saveFilterValue (state) {
    state.currentFilterValue = localStorage.getItem('filterValue')
  },
  saveHotListData (state, obj) {
    state.hotListData = obj
  },
  saveListParams (state, obj) {
    state.listParams = obj
  },
  updateHead (state, obj) {
    state.headValue = obj;
  },
  saveNormalListData (state, obj) {
    state.normalListData = obj;
  },
  saveNormalListDataPage (state, obj) {
    if (obj.currPage && obj.pageSize) {
      state.normalListDataPage = obj;
    }
  },
  saveIsHot (state, obj) {
    state.isHot = obj
  },
  saveMultipleData (state, obj) {
    state.multipleData = obj;
  },
  saveMultipleValue (state, obj) {
    state.multipleValue = obj;
  },
  saveSearchInputValue (state, obj) {
    state.searchInputValue = obj
  },
  saveId (state, obj) {
    state.detailId = obj
  },
  saveVisible (state, obj) {
    state.visible = obj
  },
  saveIsSliderNav (state, obj) {
    state.isSliderNav = obj
  },
  saveIsTopNav (state, obj) {
    state.isTopNav = obj
  },
  saveActiveShow (state, obj) {
    state.activeShow = obj
  },
  request (state) {
    vm[state.requestParameter.method](state.requestParameter.url, state.requestParameter.params).then(res => {
      if (state.requestParameter.success && typeof state.requestParameter.success === 'function') {
        state.requestParameter.success(res)
      }
    }).catch(error => {
      if (state.requestParameter.error && typeof state.requestParameter.error === 'function') {
        state.requestParameter.error(error);
      }
    })
  }
}
export default mutations



// WEBPACK FOOTER //
// ./src/store/mutations.js